<template>
  <div class="bb-bonus-cell" v-if="value">x2</div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'BonusCell',
  props: ['row', 'column', 'index'],
  computed: {
    value () {
      return _.get(this.row, this.column.prop, '')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-bonus-cell {
  @include global-font;
  width: 21px;
  height: 21px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: $color-wild-sand;
  color: $color-accent;
  font-size: 11px;
  font-weight: 600;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/BonusCell/BonusCell.vue